import dynamic from 'next/dynamic';
import { ComponentProps } from './StayDetails.types';

export const StayDetails = dynamic<ComponentProps>(() => import('./StayDetails').then(module => module.StayDetails));
